<!-- Hero Section -->
<section id="hero">
  <app-pricing-hero (yearlyChange)="isYearly = $event"></app-pricing-hero>
</section>

<!-- Plans Section -->
<section id="plans">
  <app-pricing-plans [isYearly]="isYearly"></app-pricing-plans>
</section>

<!-- Modules Section -->
<section id="modules">
  <app-pricing-modules></app-pricing-modules>
</section>

<!-- FAQ Section -->
<section id="faq">
  <app-pricing-faq></app-pricing-faq>
</section>
